function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_20026435_97313)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M9.93345 12.7613L8.08012 14.614C6.23278 16.462 3.23478 16.462 1.38612 14.614C-0.461884 12.7653 -0.461217 9.768 1.38612 7.92L3.23878 6.06733L4.65278 7.48133L2.80012 9.334C1.73478 10.3993 1.73478 12.134 2.80012 13.1987C3.86678 14.2653 5.60078 14.2653 6.66612 13.1987L8.51878 11.3473L9.93345 12.7613ZM7.92012 1.386L6.06745 3.23867L7.48145 4.65267L9.33478 2.8C10.4001 1.73467 12.1341 1.73467 13.1981 2.80067C14.2661 3.866 14.2661 5.6 13.2008 6.66533L11.3481 8.518L12.7621 9.932L14.6148 8.08C16.4621 6.23133 16.4621 3.234 14.6148 1.386C12.7654 -0.462 9.76812 -0.462 7.92012 1.386ZM3.95678 0.856L4.91678 0.72L5.20878 2.77533L4.25012 2.912L3.95678 0.856ZM0.720116 4.916L0.857449 3.95533L2.91345 4.24867L2.77612 5.20867L0.720116 4.916ZM3.91545 3.23533L3.23012 3.922L1.76012 2.45333L2.44612 1.76733L3.91545 3.23533ZM12.0428 15.142L11.0821 15.278L10.7901 13.2227L11.7494 13.086L12.0428 15.142ZM15.2801 11.082L15.1421 12.0427L13.0861 11.75L13.2241 10.7893L15.2801 11.082ZM12.0848 12.762L12.7694 12.076L14.2394 13.5453L13.5534 14.2313L12.0848 12.762Z",
  fill: "#6B7280"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_20026435_97313"
}, /*#__PURE__*/React.createElement("rect", {
  width: 16,
  height: 16,
  fill: "white"
})));

function SvgDisconnectIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisconnectIcon);
export default __webpack_public_path__ + "static/media/disconnectIcon.0a450c33357359f33853c87cb3831bfb.svg";
export { ForwardRef as ReactComponent };